// SPDX-License-Identifier: AGPL-3.0-or-later

import {ProfileEffectOverlay} from '@app/features/user/components/ProfileEffectOverlay';
import {ProfileFrameOverlay} from '@app/features/user/components/ProfileFrameOverlay';
import styles from '@app/features/user/components/profile/profile_card/ProfileCardLayout.module.css';
import {Trans} from '@lingui/react/macro';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useMemo} from 'react';

interface ProfileCardLayoutProps {
	borderColor: string;
	showPreviewLabel?: boolean;
	hoverRef?: (instance: HTMLDivElement | null) => void;
	className?: string;
	style?: React.CSSProperties;
	profileFrameUserId?: string;
	children: React.ReactNode;
}

export const ProfileCardLayout: React.FC<ProfileCardLayoutProps> = observer(
	({borderColor, showPreviewLabel = false, hoverRef, className, style, profileFrameUserId, children}) => {
		const wrapStyle = useMemo<React.CSSProperties>(() => ({...style}), [style]);
		const cardStyle = useMemo<React.CSSProperties>(() => ({borderColor}), [borderColor]);
		return (
			<div data-flx="user.profile.profile-card.profile-card-layout.div">
				{showPreviewLabel && (
					<div className={styles.previewLabel} data-flx="user.profile.profile-card.profile-card-layout.preview-label">
						<Trans>Profile preview</Trans>
					</div>
				)}
				<div
					className={clsx(styles.cardWrap, className)}
					style={wrapStyle}
					data-flx="user.profile.profile-card.profile-card-layout.card-wrap"
				>
					<div
						ref={hoverRef}
						className={styles.profileCard}
						style={cardStyle}
						data-flx="user.profile.profile-card.profile-card-layout.profile-card"
					>
						{children}
						{profileFrameUserId ? <ProfileEffectOverlay userId={profileFrameUserId} /> : null}
					</div>
					{profileFrameUserId ? <ProfileFrameOverlay userId={profileFrameUserId} fit="popout" /> : null}
				</div>
			</div>
		);
	},
);
